"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetFilteredDelegation = exports.GetFilteredDelegations = exports.GetDelegations = exports.GetDelegator = exports.GetAllDelegations = exports.GetDelegation = exports.GetIndexerDelegators = exports.DelegationFields = void 0;
const graphql_tag_1 = __importDefault(require("graphql-tag"));
exports.DelegationFields = (0, graphql_tag_1.default) `
  fragment DelegationFields on Delegation {
    id
    delegatorId
    indexerId
    amount
  }
`;
exports.GetIndexerDelegators = (0, graphql_tag_1.default) `
  query GetIndexerDelegators($id: String!, $offset: Int) {
    indexer(id: $id) {
      delegations(offset: $offset, filter: { delegatorId: { notEqualTo: $id } }) {
        totalCount
        nodes {
          ...DelegationFields
        }
      }
    }
  }
  ${exports.DelegationFields}
`;
exports.GetDelegation = (0, graphql_tag_1.default) `
  query GetDelegation($id: String!) {
    delegation(id: $id) {
      amount
    }
  }
`;
exports.GetAllDelegations = (0, graphql_tag_1.default) `
  query GetAllDelegations($offset: Int) {
    delegations(offset: $offset) {
      totalCount
      nodes {
        ...DelegationFields
      }
    }
  }
  ${exports.DelegationFields}
`;
exports.GetDelegator = (0, graphql_tag_1.default) `
  query GetDelegator($address: String!) {
    delegator(id: $address) {
      id
      totalDelegations
    }
  }
`;
exports.GetDelegations = (0, graphql_tag_1.default) `
  query GetDelegations($delegator: String!, $offset: Int) {
    delegations(filter: { delegatorId: { equalTo: $delegator } }, offset: $offset) {
      totalCount
      nodes {
        ...DelegationFields
        indexer {
          active
          metadata {
            metadataCID
            name
            url
          }
        }
      }
    }
  }
  ${exports.DelegationFields}
`;
exports.GetFilteredDelegations = (0, graphql_tag_1.default) `
  query GetFilteredDelegations($delegator: String!, $filterIndexer: String!, $offset: Int) {
    delegations(
      filter: { delegatorId: { equalTo: $delegator }, indexerId: { notEqualTo: $filterIndexer } }
      offset: $offset
    ) {
      totalCount
      nodes {
        ...DelegationFields
        indexer {
          metadata {
            metadataCID
            name
            url
          }
          active
        }
      }
    }
  }
  ${exports.DelegationFields}
`;
exports.GetFilteredDelegation = (0, graphql_tag_1.default) `
  query GetFilteredDelegation($delegator: String!, $indexer: String!, $offset: Int) {
    delegations(
      filter: { delegatorId: { equalTo: $delegator }, indexerId: { equalTo: $indexer } }
      offset: $offset
    ) {
      totalCount
      nodes {
        ...DelegationFields
        indexer {
          metadata {
            metadataCID
            name
            url
          }
          active
        }
      }
    }
  }
  ${exports.DelegationFields}
`;
//# sourceMappingURL=delegations.generated.js.map